<script setup>
import { computed } from 'vue'

const props = defineProps({
  gap: {
    type: String,
    default: '4rem',
  },
})

const authCardDt = computed(() => ({
  body: { padding: '4rem', gap: props.gap },
  root: { shadow: 'var(--shadow-card)' },
}))
</script>

<template>
  <Card :dt="authCardDt" class="auth-card">
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <template v-if="$slots.title" #title>
      <div class="text-ink font-black">
        <slot name="title" />
      </div>
    </template>
    <template v-if="$slots.subtitle" #subtitle>
      <slot name="subtitle" />
    </template>
    <template v-if="$slots.content" #content>
      <slot name="content" />
    </template>
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </Card>
</template>
